import $ from "jquery";

const $accordion_toggle = $('.accordion__button');

$accordion_toggle.on('click', function(){
  var $t = $(this).blur();
  var $accordion = $t.parents('.accordion').first();

  $accordion.toggleClass('is--open').find('.accordion__content').stop().slideToggle(250, function(){
    $accordion.find('.accordion__content').css('height', 'auto');
  });
});
